<div class="box-theme">
  <div class="head">
    <div class="header">
      <div class="ico">
        <img src="./assets/img/icono-tracking.png" alt="Consulta estado">
      </div>
    </div>
    <div class="body">
      <h1>Estado de solicitud</h1>
      <p>Consulta aquí el estado de tu solicitud.  <br/>
      </p>
    </div>
  </div>
  <div class="body">
    <div class="counter-pasos">
      <ul class="stepper-lineas">
        <li>
          <span class="linea-current"></span>
        </li>
        <li></li>
      </ul>
      <ul class="stepper">
        <li [ngClass]="{ 'numActive':pasos[0]['P1'].CurrentNum === true }">
          <p>1</p>
        </li>
        <li [ngClass]="{ 'numActive':pasos[0]['P2'].CurrentNum === true }">
          <p>2</p>
        </li>
        <li [ngClass]="{ 'numActive':pasos[0]['P3'].CurrentNum === true }">
          <p>3</p>
        </li>
      </ul>
    </div>
    <!-- PASO NUMERO 1 -->
    <div class="paso-1" *ngIf="pasos[0]['P1'].I">
      <div class="header">
        <h2>
          Para gestionar este trámite primero debes tener<br/> la siguiente información:
        </h2>
      </div>
      <div class="body">
        <ul>
          <li>
            <p class="numero">1</p>
            <p class="titulo">Número de aviso.</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <div class="callToAcction">
          <div class="mitad">
            <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
          </div>
          <div class="mitad text-right">
            <div class="info-continuar text-center">
              <p>Si ya tienes los documentos,<br/>presiona continuar</p>
              <input type="button" value="CONTINUAR" class="btn btn-continuar" (click)="gotoPaso(2, null)">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PASO NUMERO 2 -->
    <div class="paso-2" *ngIf="pasos[0]['P2'].I">
      <div class="header">
        <h2>
          Consulta aquí el estado de tu solicitud.
        </h2>
      </div>
      <div class="body">
        <form [formGroup]="formData">
          <div class="form">
            <div class="head">
              <h2>
                Identificación del solicitante
              </h2>
              <p class="txt-orange">
                (**datos obligatorios)
              </p>
            </div>
            <div class="body">
              <ul>
                  <li>
                      <div class="box-campo-form">
                          <div class="cont-numero-cliente">
                          <input type="text" placeholder="**Número de cliente" [maxLength]="9" formControlName="nCliente" [ngClass]="{ 'is-invalid': submitted && f.nCliente.errors }"/>
                          <div class="error" *ngIf="formData.get('nCliente')?.errors?.numClienteValid || formData.get('nCliente')?.errors?.numClienteExist">
                            <p>  número de cliente inválido</p>
                          </div>
                          <div class="div-numero-cliente">
                              <a style="cursor: pointer;" (click)="mostrarNumeroCliente()">
                              <img class="info-numero-cliente" src="./assets/img/info-icon.png" alt="Información número de cliente">
                              </a>
                          </div>
                          <div class="error">
                              <div *ngIf="submitted && f.nCliente.errors">
                              <p *ngIf="f.nCliente.errors.required">
                                  dato obligatorio
                              </p>
                              <p *ngIf="f.nCliente.errors.maxlength || f.nCliente.errors.pattern || f.nCliente.errors.numClienteValid">
                                  número de cliente inválido
                              </p>
                              </div>
                          </div>
                          </div>
                      </div>
                  </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Número de aviso" [maxLength]="12" formControlName="nAviso" [ngClass]="{ 'is-invalid': submitted && f.nCliente.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.nCliente.errors">
                        <p *ngIf="f.nCliente.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.nCliente.errors.maxlength || f.nCliente.errors.pattern || f.nCliente.errors.numClienteValid || f.nCliente.errors.numClienteExist">
                          número de aviso inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="form">
            <div class="footer">
              <div class="callToAcction">
                <input type="button" value="Buscar" class="btn btn-continuar center" (click)="onSubmit()">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="paso-3" *ngIf="pasos[0]['P3'].I">
      <div class="body">
        <app-solicitud-recibida
          [solicitud]="respuesta.numero_aviso"
          [plazo]="respuesta.plazo"
          [codigo]="respuesta.ConsultarEstadoAvisoPorElementosResponse.EstadoAviso"
          [mensaje]="respuesta.ConsultarEstadoAvisoPorElementosResponse.Mensajes.item.TxtMensajes"
          [nCliente]="formData.get('nCliente').value"
          [nAviso]="formData.get('nAviso').value">
        </app-solicitud-recibida>
      </div>
    </div>
  </div>
</div>

<div class="modal-requerido">
  <div class="punto-informacion">
    <h3>Debes completar todos los datos solicitados para continuar</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-error">
  <div class="punto-informacion">
    <h3>Ha ocurrido un error, vuelva a intentarlo más tarde</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-error-aviso">
  <div class="punto-informacion">
    <h3>El numero de aviso no existe, favor verifique</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-error-cliente">
  <div class="punto-informacion">
      <h3>El número de cliente no existe o es erróneo</h3>
      <div class="callToAcction">
          <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
      </div>
  </div>
</div>

<div class="modal-numero-cliente">
  <div class="punto-informacion">
    <!--<img class='img-numero-cliente' src='./assets/img/numero_cliente.png'>-->
    <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
    <p class="texto-numero-cliente">
      Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
      <!--El número de cliente aparece en la parte superior de su boleta de gas.-->
    </p>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<ngx-spinner></ngx-spinner>
